import React from 'react';
import { useFrontload } from 'react-frontload';
import { useDispatch } from 'react-redux';
import { RecommendationsFacets } from '../../lib/api';
import { fetchLandingPage } from '../../redux/landing_page';
import { IceLandingPage } from './ice_landing_page';

interface OwnProps {
  slug: string;
}

const IceLandingPageContainer = (props: OwnProps) => {
  const dispatch = useDispatch();

  useFrontload('IceLandingPageContainer', async () => {
    const query = {
      [RecommendationsFacets.subcategories]: [
        'accessories-iceaccessories',
        'accessories-iceauger',
        'apparel-icefishing',
        'accessories-iceshelters',
        'lines-iceline',
        'reels-icefishing',
        'rods-icefishing',
        'hardbaits-bladebaits',
        'softbaits-panfish',
        'terminal-bobbers',
      ],
      [RecommendationsFacets.styles]: ['ice_jigs', 'ice_spoons'],
    };

    await dispatch(fetchLandingPage(props.slug, query));

    return true;
  });

  return <IceLandingPage />;
};

export default IceLandingPageContainer;
